const countries = require('../data/geo-list_1.0.0.json');
export default countries;
